export default __webpack_public_path__ + "static/media/strat.f576a13d.jpg";